import { __extends } from "tslib";
import React from "react";
import { InputNumber } from "../inputs/InputNumber";
import { ITranslations } from "../../models/translations";
var RowsLimitInput = (function (_super) {
    __extends(RowsLimitInput, _super);
    function RowsLimitInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderOffsetField = function () {
            var _a = _this.props, startWithRow = _a.startWithRow, onStartWithRowChanged = _a.onStartWithRowChanged, showRowsOffset = _a.showRowsOffset, t = _a.t;
            if (!showRowsOffset) {
                return null;
            }
            return (React.createElement("div", { className: "rb-limit-rows-input-container" },
                React.createElement("div", { className: "rb-title-dark rb-title-extra-small", style: { marginTop: 20 } }, t.rowsOffset),
                React.createElement(InputNumber, { value: startWithRow, minValue: 0, onChange: onStartWithRowChanged })));
        };
        _this.renderRowsLimitField = function () {
            var _a = _this.props, limitRowsTo = _a.limitRowsTo, onLimitRowsToChanged = _a.onLimitRowsToChanged, showRowsLimit = _a.showRowsLimit, maxRowsLimit = _a.maxRowsLimit, t = _a.t;
            if (!showRowsLimit) {
                return null;
            }
            return (React.createElement("div", { className: "rb-limit-rows-input-container" },
                React.createElement("div", { className: "rb-title-dark rb-title-extra-small", style: { marginTop: "20px" } }, t.rowsLimit),
                React.createElement(InputNumber, { value: limitRowsTo, minValue: 0, maxValue: maxRowsLimit, onChange: onLimitRowsToChanged })));
        };
        return _this;
    }
    RowsLimitInput.prototype.render = function () {
        return (React.createElement("div", { className: "rb-limit-rows-to-container" },
            this.renderOffsetField(),
            this.renderRowsLimitField()));
    };
    return RowsLimitInput;
}(React.PureComponent));
export { RowsLimitInput };
